// ai-value-engine.js
// Shared AI value logic for Grader + Collection Calculator

// 🔒 STABLE — ROI + Trends + Volatility VERIFIED — DO NOT EDIT

(function () {
  console.log("🧠 GCA AI Value Engine loaded");

  // --- Grade estimation (based on your AI grader logic) ---
  function estimateGrade(condition, year, status) {
    year = parseInt(year, 10) || new Date().getFullYear();

    // If already graded, treat condition as numeric (8, 9, 10 etc)
    if (status === "graded") {
      const numeric = parseFloat(condition);
      if (!isNaN(numeric)) return numeric;
      return 9.0;
    }

    let base = 9.0;

    if (condition === "gem") base = 9.6;
    else if (condition === "nmmt") base = 9.2;
    else if (condition === "ex") base = 8.3;
    else if (condition === "poor") base = 6.5;

    // Slight penalty for older cards
    if (year <= 1990) base -= 0.3;

    return Math.min(10, Math.max(1, base));
  }

  // --- Multipliers for PSA / SGC / CGA / BGS (your existing ranges) ---
  function multipliers(psa) {
    if (psa >= 9.6) {
      return {
        psa: { l: 2.2, h: 3.0 },
        sgc: { l: 1.9, h: 2.6 },
        cga: { l: 1.8, h: 2.4 },
        bgs: { l: 2.0, h: 2.8 },
      };
    }
    if (psa >= 9.2) {
      return {
        psa: { l: 1.8, h: 2.2 },
        sgc: { l: 1.3, h: 1.7 },
        cga: { l: 1.25, h: 1.55 },
        bgs: { l: 1.55, h: 2.0 },
      };
    }
    if (psa >= 8.8) {
      return {
        psa: { l: 1.4, h: 1.8 },
        sgc: { l: 1.1, h: 1.4 },
        cga: { l: 1.05, h: 1.25 },
        bgs: { l: 1.3, h: 1.6 },
      };
    }
    if (psa >= 8.3) {
      return {
        psa: { l: 1.0, h: 1.2 },
        sgc: { l: 0.9, h: 1.1 },
        cga: { l: 0.85, h: 1.05 },
        bgs: { l: 0.95, h: 1.15 },
      };
    }
    return {
      psa: { l: 0.9, h: 1.0 },
      sgc: { l: 0.7, h: 0.9 },
      cga: { l: 0.65, h: 0.85 },
      bgs: { l: 0.8, h: 1.0 },
    };
  }

  function gradingFees(service) {
  switch (service) {
    case "psa": return 35;
    case "sgc": return 30;
    case "cga": return 15;
    case "bgs": return 40;
    default: return 30; // safe default
  }
}

  // --- Type boost (rookie, DPS, patch, etc) ---
  function boost(type) {
    switch (type) {
      case "rookie":
        return 1.25;
      case "draftpick":
        return 1.5;
      case "parallel":
        return 1.2;
      case "patch":
        return 1.3;
      case "patchauto":
        return 1.6;
      case "auto":
        return 1.3;
      case "numbered":
        return 1.25;
      case "insert":
        return 1.1;
      default:
        return 1.0;
    }
  }

  // --- Single-card AI estimation used by the Collection Calculator ---
  // card = { year, status, condition, type, rawValue, gradedValue }
  function estimateCard(card) {
    const year = parseInt(card.year, 10) || new Date().getFullYear();
    const status = card.status || "raw";
    const condition = card.condition || (status === "graded" ? "9" : "nmmt");
    const type = card.type || "base";
    const rawValue = Number(card.rawValue) || 0;
    const gradedValueInput = Number(card.gradedValue) || 0;

    // If already graded: treat the provided graded value as the base
    if (status === "graded") {
      const base = gradedValueInput > 0 ? gradedValueInput : rawValue;
      if (base <= 0) {
        return null;
      }

      const low = base * 0.9;
      const high = base * 1.1;

      return {
        psaEstimate: null,
        rawValue: base,
        gradedLow: low,
        gradedHigh: high,
        roiLow: 0,
        roiHigh: 0,
        investLabel: "Hold Slab",
        investText: "Already graded — focus on timing the sale for peak demand.",
      };
    }

    // If raw and no value, skip
    if (rawValue <= 0) {
      return null;
    }

    const psa = estimateGrade(condition, year, status);
    const m = multipliers(psa);
    const tBoost = boost(type);
    
    // MATERIALISE CGA valuation bands (AUS context)
const cgaLow = rawValue * m.cga.l * tBoost;
const cgaHigh = rawValue * m.cga.h * tBoost;


    // Use CGA band as the main collection estimate (Aussie context)
   const fee = gradingFees("cga");

   const netLow = cgaLow - fee;
   const netHigh = cgaHigh - fee;

   const roiLow = ((cgaLow - rawValue) / rawValue) * 100;
   const roiHigh = ((cgaHigh - rawValue) / rawValue) * 100;

   const netRoiLow = ((netLow - rawValue) / rawValue) * 100;
   const netRoiHigh = ((netHigh - rawValue) / rawValue) * 100;

   // --- Trend Projections (Premium Analytics) ---

const confidence =
  typeof card.marketConfidence === "number"
    ? card.marketConfidence
    : 0.65; // neutral default

const volatilityScore =
  typeof card.marketVolatility?.score === "number"
    ? card.marketVolatility.score
    : 0.35; // moderate default

// dampen extreme projections when volatility is high
const volatilityDampener = Math.max(0.6, 1 - volatilityScore);

// helper to project ROI forward
function projectROI(roi, weight) {
  return roi * weight * confidence * volatilityDampener;
}

const trendProjections = {
  d30: {
    low: projectROI(roiLow, 0.15),
    high: projectROI(roiHigh, 0.15),
  },
  d90: {
    low: projectROI(roiLow, 0.35),
    high: projectROI(roiHigh, 0.35),
  },
  d365: {
    low: projectROI(roiLow, 0.75),
    high: projectROI(roiHigh, 0.75),
  },
};

// --- Volatility & Confidence Interpretation (Premium Analytics) ---

let confidenceLabel = "Medium";
if (confidence >= 0.8) confidenceLabel = "High";
else if (confidence < 0.55) confidenceLabel = "Low";

let volatilityLabel = "Moderate";
let volatilityAdvice = "Balanced risk — monitor market conditions.";

if (volatilityScore < 0.25) {
  volatilityLabel = "Low";
  volatilityAdvice = "Stable pricing — suitable for holding.";
} else if (volatilityScore > 0.55) {
  volatilityLabel = "High";
  volatilityAdvice = "Price swings detected — flipping is safer.";
}

  let investLabel = "Sell Raw";
    let investText = "Modest grading upside — may be better to sell raw.";

    if (psa >= 9.5 && roiLow > 50) {
      investLabel = "Grade & Hold";
      investText = "Strong grading upside and long-term hold potential.";
    } else if (psa >= 9.0 && roiLow > 20) {
      investLabel = "Grade & Flip";
      investText = "Good grading upside — ideal for flipping after grading.";
    }

    return {
      psaEstimate: psa,
      rawValue: rawValue,
      gradedLow: cgaLow,
      gradedHigh: cgaHigh,
      roiLow: roiLow,
      roiHigh: roiHigh,
      trendProjections,
      investLabel: investLabel,
      investText: investText,
      netRoiLow,
      netRoiHigh,
      gradingFee: fee,
      confidenceLabel,
      volatilityLabel,
      volatilityAdvice,


    };
  }

  // Expose globally
  window.GCAValueEngine = {
    estimateCard: estimateCard,
  };
})();
/* ================================
   STEP 1 — MOCK MARKET ADAPTER
   ================================ */

window.GCAMarketMock = {
  getMarketData(cardKey) {
    console.log("📊 Mock market lookup:", cardKey);

    const mockDB = {
      "nick-daicos-2021-select-dp4": {
        status: "ok",
        market: {
          currency: "AUD",
          timeframeDays: 90,
          sampleSize: 42,
          price: { low: 160, median: 195, high: 220 },
          velocity: { soldLast30: 11, soldLast90: 42 },
          volatility: { score: 0.28, label: "Low" },
          confidence: 0.82
        }
      }
    };

    return mockDB[cardKey] || {
      status: "unavailable",
      reason: "no_mock"
    };
  }
};
/* ================================
   STEP 2 — MARKET-AWARE AI WRAPPER
   ================================ */

window.GCAValueEngine.estimateWithMarket = function (card, queryKey) {
  // 1️⃣ Run core AI logic first (single source of truth)
  const ai = window.GCAValueEngine.estimateCard(card);
  if (!ai) return null;

  // Default flags
  ai.marketBacked = false;
  ai.marketConfidence = 0;

  // 2️⃣ Pull market data (mock for now)
  const marketResponse =
    window.GCAMarketMock &&
    typeof window.GCAMarketMock.getMarketData === "function"
      ? window.GCAMarketMock.getMarketData(queryKey)
      : null;

  // 3️⃣ If no usable market data, return pure AI result
  if (
    !marketResponse ||
    marketResponse.status !== "ok" ||
    !marketResponse.market
  ) {
    return ai;
  }

  const market = marketResponse.market;

  // 4️⃣ Clamp valuation bands using market reality
  if (typeof market.price?.low === "number") {
    ai.gradedLow = Math.max(ai.gradedLow, market.price.low);
  }

  if (typeof market.price?.high === "number") {
    ai.gradedHigh = Math.min(ai.gradedHigh, market.price.high);
  }

  // 5️⃣ Recalculate ROI bands after clamping
  if (ai.rawValue > 0) {
    ai.roiLow = ((ai.gradedLow - ai.rawValue) / ai.rawValue) * 100;
    ai.roiHigh = ((ai.gradedHigh - ai.rawValue) / ai.rawValue) * 100;
  }

  // 6️⃣ Liquidity-aware decision adjustment
  if (
    market.velocity?.soldLast30 !== undefined &&
    market.velocity.soldLast30 < 3 &&
    ai.investLabel.includes("Hold")
  ) {
    ai.investLabel = "Grade & Flip";
    ai.investText += " Market liquidity suggests faster flips outperform holds.";
  }

  // 7️⃣ Attach market metadata (for UI / confidence)
  ai.marketBacked = true;
  ai.marketConfidence = market.confidence || 0;
  ai.marketMedian = market.price?.median || null;
  ai.marketVolatility = market.volatility || null;

  return ai;
};

setTimeout(() => {
  console.log("🧪 FORCED TEST START");

  const firstCard = document.querySelector(".gca-cc-card");
  if (!firstCard) {
    console.log("❌ No card found");
    return;
  }

  console.log("✅ Card found, forcing ROI calc");
  renderPremiumInsight(firstCard);
}, 2000);

/* ============================================================
   GCA LIVE MARKET ADAPTER (NON-BLOCKING)
   - Enriches AI estimates with live eBay data
   - NEVER throws
   - NEVER blocks UI
============================================================ */

const GCA_MARKET_WORKER =
  "https://gca-ebay-oauth.gareth-faz.workers.dev";

async function gcaFetchMarket(queryKey) {
  try {
    const res = await fetch(
      `${GCA_MARKET_WORKER}/market/estimate?queryKey=${encodeURIComponent(queryKey)}`
    );
    const data = await res.json();

    if (data?.status === "ok") {
      return data;
    }
  } catch (e) {
    console.warn("⚠️ Market fetch failed:", e);
  }

  return null;
}
// Preserve original estimator
const _estimateCard = window.GCAValueEngine.estimateCard;

// Add market-enhanced estimator
window.GCAValueEngine.estimateWithMarket = async function (card, queryKey) {
  // 1️⃣ Run core AI logic (always)
  const ai = _estimateCard(card);

  // 2️⃣ Attempt live market enrichment (optional)
  const marketData = await gcaFetchMarket(queryKey);

  if (marketData?.market) {
    ai.market = marketData.market;
    ai.liquidity = marketData.liquidity;
    ai.marketBacked = true;
  } else {
    ai.marketBacked = false;
  }

  return ai;
};
